import { Badge } from "@package/subframe/components/Badge";
import { Button } from "@package/subframe/components/Button";

import type { EmployeeDirectoryAcknowledgementsDto } from "@/generated/model/employeeDirectoryAcknowledgementsDto";
import {
  acknowledgementSummaryAction,
  acknowledgementSummaryText,
} from "@/lib/people-acknowledgements";
import {
  acknowledgementLabel,
  acknowledgementVariant,
} from "@/lib/people-directory";
import { cn } from "@/lib/utils";

interface ProfileAcknowledgementsSummaryProps {
  summary: EmployeeDirectoryAcknowledgementsDto;
  /** How to call the person in a sentence, e.g. their preferred name. */
  name: string;
  isOwnProfile: boolean;
  onOpen: () => void;
  className?: string;
}

export function ProfileAcknowledgementsSummary({
  summary,
  name,
  isOwnProfile,
  onOpen,
  className,
}: ProfileAcknowledgementsSummaryProps) {
  return (
    <div
      data-testid="profile-ack-summary"
      className={cn(
        "flex-col items-start gap-2 rounded-md border border-solid border-neutral-200 bg-neutral-50 p-4 lg:w-72 lg:shrink-0",
        className,
      )}
    >
      <span className="text-body-bold font-body-bold text-default-font">
        Acknowledgements
      </span>
      <span className="text-body font-body text-subtext-color">
        {acknowledgementSummaryText(summary, name, isOwnProfile)}
      </span>
      <div className="flex w-full flex-wrap items-center justify-between gap-2">
        <Badge variant={acknowledgementVariant(summary.standing)}>
          {acknowledgementLabel(summary)}
        </Badge>
        <Button variant="neutral-secondary" size="small" onClick={onOpen}>
          {acknowledgementSummaryAction(summary, isOwnProfile)}
        </Button>
      </div>
    </div>
  );
}
